var _defs, _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "defenseJrPanel",
    "data-name": "Defense Jr Panel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Defense-cls-1{fill:#1a0a00;}.Defense-cls-2{fill:#14163d;}.Defense-cls-3{fill:#a335f9;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Defense-cls-1",
    cx: 65,
    cy: 65,
    r: 65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "Defense-cls-2",
    cx: 65,
    cy: 65,
    r: 65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Defense-cls-3",
    d: "M178,116.86l-40.86,18.85s0,33.95,13.58,54.8c6,9.24,27.28,15.92,27.28,15.92,1.57,0,22-7.25,28-17.11,12.84-20.94,12.84-53.61,12.84-53.61Zm-1.57,84.85s-17.29-7.85-22-12.57c-11-14.14-12.57-50.28-12.57-50.28l34.57-15.72Z",
    transform: "translate(-113 -92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefense);
export default __webpack_public_path__ + "static/media/Defense.2562a74c3b3c61a9515b821cc9acbffb.svg";
export { ForwardRef as ReactComponent };